"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70",
    height: "70",
    viewBox: "0 0 70 70"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35,0A35,35,0,1,0,70,35,35,35,0,0,0,35,0Z",
    fill: "#024b6a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M49.61,46.87,37.75,35,49.62,23.14a2,2,0,0,0,0-2.75,1.94,1.94,0,0,0-2.75,0L35,32.26,23.14,20.4a1.91,1.91,0,0,0-1.37-.57,1.94,1.94,0,0,0-1.38.57,1.94,1.94,0,0,0,0,2.75L32.25,35,20.4,46.86a1.91,1.91,0,0,0-.57,1.37,1.94,1.94,0,0,0,.57,1.38,1.94,1.94,0,0,0,2.75,0L35,37.76,46.86,49.62a2,2,0,0,0,2.75,0A1.94,1.94,0,0,0,49.61,46.87Z",
    fill: "#fff"
  }));
};

exports["default"] = _default;